export default __webpack_public_path__ + "static/media/ms.6e4daae9.svg";